import {Feature} from "../model/feature.model";

export class CreateFeatureDto extends Feature {

  constructor() {
    super();
  }

}
